var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHerdez(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "GrupoHerdez_logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 39.133,
    height: 38.707,
    viewBox: "0 0 39.133 38.707",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6232",
    "data-name": "Rect\\xE1ngulo 6232",
    width: 39.133,
    height: 38.707
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14991",
    clipPath: "url(#clipPath)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_731",
    d: "M39.188,0a1.9,1.9,0,0,0-1.9,1.87h0V8.529H28.593V0H21.77A1.869,1.869,0,0,0,19.9,1.87V25.52a35.984,35.984,0,0,1,4.625-.886c1.968-.3,4.1-.394,4.1-.394v-7.02h8.725v7.118s2.263.164,4.592.492c1.378.2,2.755.492,4.133.82V0Z",
    transform: "translate(-13.372)",
    fill: "#c10230"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_732",
    d: "M44.876,105.083V100.95h.918a.812.812,0,0,1,.82.82v.033a.758.758,0,0,1-.623.82h-.918a.818.818,0,0,1,.623.59c.394,1.279.722,2.427,1.8,2.591a2.017,2.017,0,0,0,.886,0c.033,0,.066-.033.1-.033l-.033-.033a2.346,2.346,0,0,1-.59-1.082,3.791,3.791,0,0,0-.623-1.443,1.489,1.489,0,0,0,.787-1.443,1.78,1.78,0,0,0-.525-1.378,2,2,0,0,0-1.345-.492H43.4v4.428c0,.525.1.754.722.754Z",
    transform: "translate(-29.164 -67.13)",
    fill: "#c10230"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_733",
    d: "M20.8,99.8v5.216h-.722c-.623,0-.722-.23-.722-.754v-1.246H17.843v2h-.82c-.558,0-.623-.164-.623-.656V99.8h1.476v2h1.509v-2Z",
    transform: "translate(-11.02 -67.063)",
    fill: "#c10230"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_734",
    d: "M86.5,99.8v1.115h2.427c-.23.3-2.263,2.854-2.263,2.854a.806.806,0,0,0-.164.492h0c0,.525.1.754.722.754H90.83V104H88.7c-.131,0-.2,0-.23-.1s.033-.164.131-.3l2.231-2.788V99.8Z",
    transform: "translate(-58.126 -67.063)",
    fill: "#c10230"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_735",
    d: "M100.861,113.689v-.164h.1l.033.033v.131h.131v-.066a.12.12,0,0,0-.033-.1c-.033,0-.033-.033-.066-.033.033,0,.066,0,.066-.033a.12.12,0,0,0,.033-.1c0-.033-.033-.1-.066-.1s-.066-.033-.1-.033h-.23v.459Zm.131-.328c0,.033,0,.033-.033.066-.033,0-.033.033-.066.033h-.033v-.131h.1c0-.033.033,0,.033.033m.361.066a.418.418,0,0,0-.722-.3.38.38,0,0,0-.131.328.356.356,0,0,0,.131.3.416.416,0,0,0,.59,0,.583.583,0,0,0,.131-.328m-.459-.328a.372.372,0,0,1,.262.1.348.348,0,0,1-.492.492.4.4,0,0,1,0-.525.608.608,0,0,1,.23-.066",
    transform: "translate(-67.533 -75.933)",
    fill: "#c10230"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_736",
    d: "M34.252,103.015V101.8H32.743v-.886h2.1V99.8H31.3v4.166c0,.623,0,1.05.656,1.05h2.919V103.9h-1.8a.277.277,0,0,1-.23-.066.381.381,0,0,1-.066-.328v-.492Z",
    transform: "translate(-21.033 -67.063)",
    fill: "#c10230"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_737",
    d: "M77.352,103.015V101.8H75.843v-.886h2.1V99.8H74.4v4.166c0,.623,0,1.05.656,1.05h2.919V103.9h-1.8a.277.277,0,0,1-.23-.066.381.381,0,0,1-.066-.328v-.492Z",
    transform: "translate(-49.995 -67.063)",
    fill: "#c10230"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_738",
    d: "M60.635,104c-.426,0-.492-.328-.492-.787v-2.329h.492a1.428,1.428,0,0,1,1.411,1.443v.131c0,1.411-.951,1.542-1.411,1.542M58.7,99.8v4.068c0,.656.066,1.148.984,1.148.262,0,.82.033,1.246,0,2.067,0,2.493-1.345,2.493-2.591A2.308,2.308,0,0,0,60.931,99.8Z",
    transform: "translate(-39.445 -67.063)",
    fill: "#c10230"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_739",
    d: "M42.224,91.691a3.435,3.435,0,0,1-.984.164,1.828,1.828,0,0,1-1.214-.361,1.2,1.2,0,0,1-.426-.984c0-.886.722-1.411,1.706-1.411a2.265,2.265,0,0,1,.82.131l-.164.492a1.713,1.713,0,0,0-.689-.131.89.89,0,1,0-.164,1.771h.131a1.116,1.116,0,0,0,.328-.033v-.558h-.459v-.459h1.115Z",
    transform: "translate(-26.61 -59.873)",
    fill: "#807f80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_740",
    d: "M49.089,90.33h.262c.328,0,.525-.164.525-.394,0-.262-.2-.361-.492-.361a.908.908,0,0,0-.3.033Zm-.656-1.181a8.046,8.046,0,0,1,.886-.066,1.615,1.615,0,0,1,.951.2.554.554,0,0,1,.262.558.7.7,0,0,1-.525.656h0a.733.733,0,0,1,.394.492c.066.262.164.525.23.754h-.689a2.286,2.286,0,0,1-.2-.623c-.066-.328-.2-.426-.492-.426h-.2v1.05H48.4V89.149Z",
    transform: "translate(-32.524 -59.856)",
    fill: "#807f80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_741",
    d: "M56.456,89.133v1.542c0,.459.2.689.525.689.361,0,.558-.23.558-.689V89.133h.689v1.509a1.1,1.1,0,0,1-.984,1.214h-.262c-.754,0-1.181-.361-1.181-1.246V89.1Z",
    transform: "translate(-37.496 -59.873)",
    fill: "#807f80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_742",
    d: "M64.956,90.4c.066,0,.164.033.23,0,.361,0,.59-.164.59-.426s-.2-.394-.525-.394a.908.908,0,0,0-.3.033ZM64.3,89.153a8.063,8.063,0,0,1,.918-.066,1.539,1.539,0,0,1,.918.23.746.746,0,0,1,.328.623.84.84,0,0,1-.262.623,1.736,1.736,0,0,1-.984.3h-.23v.951h-.656Z",
    transform: "translate(-43.208 -59.86)",
    fill: "#807f80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_743",
    d: "M71.719,90.5c0,.525.262.886.722.886s.722-.394.722-.918c0-.492-.262-.886-.722-.886s-.722.394-.722.918m2.165-.066A1.332,1.332,0,0,1,72.6,91.845h-.2A1.342,1.342,0,0,1,71,90.631V90.5a1.359,1.359,0,0,1,1.312-1.411h.131A1.319,1.319,0,0,1,73.851,90.3a.2.2,0,0,1,.033.131",
    transform: "translate(-47.708 -59.862)",
    fill: "#807f80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_744",
    d: "M39.133,79.536S32.868,75.6,19.091,75.6,0,79.536,0,79.536l1.378.394s4.953-1.9,17.779-1.9,18.96,1.9,18.96,1.9Z",
    transform: "translate(0 -50.801)",
    fill: "#c10230"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHerdez);
export default __webpack_public_path__ + "static/media/Herdez.3d2b4f98f918191245120445b66c8545.svg";
export { ForwardRef as ReactComponent };